export default __webpack_public_path__ + "static/media/radijator.68f469a8.jpg";